export enum ProductColors {
  F500 = '#045B62',
  F400 = '#1A756C',
  F300 = '#32A0A9',
  F200 = '#67C8D0',
  F100 = '#92D8DD',
  F75 = '#B0E4E8',
  F50 = '#E8F7F8',
  F999 = '#28534E',
  B500 = '#1B3888',
  B400 = '#1A42B2',
  B300 = '#5575CE',
  B200 = '#889FDD',
  B100 = '#B4C2E9',
  B75 = '#C7D2EF',
  B50 = '#E3E9F7',
  P500 = '#542C77',
  P400 = '#6B2F9F',
  P300 = '#985DCB',
  P200 = '#B388D8',
  P100 = '#C7A7E2',
  P75 = '#DDC9ED',
  P50 = '#F3ECF9',
  R400 = '#C72800',
  R500 = '#A82605',
  R300 = '#E34E1C',
  R200 = '#E3805F',
  R100 = '#EAA28A',
  R75 = '#F0BEAD',
  R50 = '#FFECE5',
  Y500 = '#BB7907',
  Y400 = '#EC9C00',
  Y300 = '#FFA800',
  Y200 = '#F6BE51',
  Y100 = '#F8D081',
  Y75 = '#FAE0AD',
  Y50 = '#FCEBCA',
  G600 = '#02BA4D',
  G500 = '#04623B',
  G400 = '#00844D',
  G300 = '#3EAC44',
  G200 = '#6EB973',
  G100 = '#ACD7AF',
  G75 = '#C4E3C7',
  G50 = '#E3F2E5',
  N11 = '#E3F2E5',
  N1000 = '#E3F2E5',
  N900 = '#00283B',
  C100 = '#13544e',
  O80 = '#ffbb32',
}
export enum LightThemeColors {
  N10 = '#FAFBFB',
  N11 = '#EFFEF5',
  N20 = '#F5F7F7',
  N30 = '#EBEEF0',
  N40 = '#DEE3E6',
  N50 = '#7F7F7F',
  N60 = '#B0BCC2',
  N70 = '#A3B1B8',
  N80 = '#94A5AD',
  N90 = '#191919',
  N100 = '#758B95',
  N200 = '#667E89',
  N300 = '#57717E',
  N400 = '#4A6674',
  N500 = '#3B5A68',
  N600 = '#2E4F5E',
  N700 = '#1C4050',
  N800 = '#0D3345',
  N900 = '#00283B',
  N1000 = '#806695',
}
export enum NeutralColors {
  black = '#000000',
  white = '#FFFFFF',
  N60 = '#666666',
}
export enum DarkThemeColors {
  D10 = '#FAFAFA',
  D20 = '#F6F6F6',
  D30 = '#ECECEC',
  D40 = '#E0E0E0',
  D50 = '#C3C3C3',
  D60 = '#B6B6B6',
  D70 = '#A9A9A9',
  D80 = '#9C9C9C',
  D90 = '#8E8E8E',
  D100 = '#7F7F7F',
  D200 = '#717171',
  D300 = '#636363',
  D400 = '#575757',
  D500 = '#494949',
  D600 = '#3D3D3D',
  D700 = '#2C2C2C',
  D800 = '#1E1E1E',
  D900 = '#121212',
}
